import { LocationQuery } from 'vue-router';
import { WorkerTypeService } from './worker-type.service';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { WorkerType, WorkerTypeException } from './worker-type.interface';

const service = new WorkerTypeService();

export interface WorkerTypeState {
   workerTypes: Array<WorkerType>;
   workerTypeExceptions: Array<WorkerTypeException>;
}

const WorkerTypeStore: Module<WorkerTypeState, StoreState> = {
   namespaced: true,
   state: {
      workerTypes: [],
      workerTypeExceptions: [],
   },
   getters: {
      workerTypes(state) {
         return state.workerTypes;
      },
   },
   mutations: {
      SET_WORKER_TYPES(state, workerTypes: Array<WorkerType>) {
         state.workerTypes = workerTypes;
      },
      SET_WORKER_TYPE_EXCEPTIONS(state, workerTypeExceptions: Array<WorkerTypeException>) {
         state.workerTypeExceptions = workerTypeExceptions;
      },
   },
   actions: {
      async getFilteredWorkerTypes(context, query?: LocationQuery) {
         return await service.getWorkerTypes(query);
      },
      async getWorkerTypes(context, query?: LocationQuery) {
         const response = await service.getWorkerTypes(query);
         context.commit('SET_WORKER_TYPES', response);
         return response;
      },
      async getWorkerTypeExceptions(context, query?: LocationQuery) {
         const response = await service.getWorkerTypeExceptions(query);
         context.commit('SET_WORKER_TYPE_EXCEPTIONS', response);
         return response;
      },
   },
};

export default WorkerTypeStore;
